export default __webpack_public_path__ + "static/magic_store-8a191bcd82331cb5e8f6bc314b3927e8.svg";